import { Box } from '@mui/material';
import versionData from '../version.json';

function Footer() {
    return (
        <Box
            component='footer'
            sx={{
                // Pinned to the very bottom of the viewport, matching the live
                // sandbox app's footer (position: fixed, bottom: 0).
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1200,
                textAlign: 'center',
                px: 1.5,
                py: 0.5,
                fontSize: '0.75rem',
                color: 'rgba(255, 255, 255, 0.3)',
                backgroundColor: '#1f2329',
                borderTop: '1px solid #333',
            }}
        >
            v{versionData.version} · Nakomis Home
        </Box>
    );
}

export default Footer;
